var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('div',{ref:"map",attrs:{"id":"map"}}),_c('div',{staticClass:"map__overlay"},[_vm._t("overlay")],2),_c('div',{staticClass:"map__wrapper"},[(_vm.load_more !== null && _vm.map_markers.length > 1)?_c('vb-button',{staticClass:"map__load-more",attrs:{"vb_options":{
        text: _vm.loading ? 'Caricamento' : 'Mostra più risultati',
        variant: 'primary',
        size: 'md',
        disabled: _vm.loading,
      }},on:{"click":function($event){return _vm.load_more()}}},[(_vm.loading)?_c('loader',{staticClass:"ml-2"}):_vm._e()],1):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }